import { request, mcRequest } from "../utils";

export const getPreference = () => request(`/staff/preference/settings`);

export const putPreference = (data) => request(`/staff/preference/settings`, {
  method: 'PUT',
  data,
});
